import { render, staticRenderFns } from "./my-loader.vue?vue&type=template&id=350539f1&scoped=true&"
var script = {}
import style0 from "./my-loader.vue?vue&type=style&index=0&id=350539f1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350539f1",
  null
  
)

export default component.exports